// Mirror of the server's parseInlineMarkup (textOverlay.js): **bold**,
// *italic*, ***both***; unmatched markers are literal copy. Shared by the
// editor preview and the client canvas renderer so they cannot drift.
export type InlineSegment = { text: string; bold: boolean; italic: boolean };

/** The lines a renderer actually draws: both final renderers (client canvas
 * and server SVG) drop empty entries, so the DOM preview must too — one
 * shared filter keeps all three in agreement. */
export function renderableLines(lines: ReadonlyArray<string> | null | undefined): string[] {
  return (lines || []).map(String).filter(l => l.length > 0);
}

export function parseInlineMarkup(line: string): InlineSegment[] {
  const segments: InlineSegment[] = [];
  const push = (text: string, bold: boolean, italic: boolean) => { if (text) segments.push({ text, bold, italic }); };
  let i = 0;
  let plain = '';
  const markers: Array<[string, boolean, boolean]> = [['***', true, true], ['**', true, false], ['*', false, true]];
  while (i < line.length) {
    let matched = false;
    for (const [marker, bold, italic] of markers) {
      if (!line.startsWith(marker, i)) continue;
      const close = line.indexOf(marker, i + marker.length);
      if (close === -1 || close === i + marker.length) continue;
      push(plain, false, false);
      plain = '';
      push(line.slice(i + marker.length, close), bold, italic);
      i = close + marker.length;
      matched = true;
      break;
    }
    if (!matched) { plain += line[i]; i += 1; }
  }
  push(plain, false, false);
  return segments.length ? segments : [{ text: '', bold: false, italic: false }];
}
